export const popperCommonProps = {
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: ({ placement }: { placement: 'bottom' | 'top' | 'left' | 'right' }) => {
          if (placement === 'top') {
            return [0, 8];
          } else {
            return [0, 4];
          }
        },
      },
    },
  ],
};
